module.exports = __webpack_public_path__ + "images/giftTree/solidarity.055e22281758a9fb0b79d5b235448206.png";